import {
  Building2,
  CheckCircle2,
  Home,
  Settings,
  Shield,
  User,
  UserCheck,
} from "lucide-react";

import { FormData, PropertyLocal, Step, TenantInfo } from "./types";

export const STEPS: Omit<Step, "completed">[] = [
  {
    number: 1,
    title: "Elige Inmueble",
    shortTitle: "Inmueble",
    subtitle: "Selecciona la propiedad",
    icon: Building2,
  },
  {
    number: 2,
    title: "Elige Inquilino",
    shortTitle: "Inquilino",
    subtitle: "Datos del arrendatario",
    icon: User,
  },
  {
    number: 3,
    title: "¿Fiador Requerido?",
    shortTitle: "Fiador",
    subtitle: "Configurar garantías",
    icon: Shield,
  },
  {
    number: 4,
    title: "Configuración",
    shortTitle: "Config.",
    subtitle: "Opciones adicionales",
    icon: Settings,
  },
  {
    number: 5,
    title: "Resumen",
    shortTitle: "Resumen",
    subtitle: "Confirma tu solicitud",
    icon: CheckCircle2,
  },
];

export const PROPERTY_REGISTRATION_STEPS: Omit<Step, "completed">[] = [
  {
    number: 1,
    title: "Inmueble",
    shortTitle: "Inmueble",
    subtitle: "Datos del inmueble",
    icon: Home,
  },
  {
    number: 2,
    title: "Propietario",
    shortTitle: "Propietario",
    subtitle: "Datos del propietario",
    icon: UserCheck,
  },
];

export const DEFAULT_PROPERTIES: PropertyLocal[] = [
  {
    id: "inmueble-inicio",
    label: "Inmueble Inicio",
    alias: "Inmueble Inicio",
    direccion: "POR AHI 12",
    colonia: "EL ESPINAL",
    uso: "industrial",
  },
];

export const INITIAL_FORM_DATA: FormData = {
  property: "",
  propertyUse: "",
  rentAmount: "",
  maintenanceAmount: "",
  address: "",
  alias: "",
  colony: "",
  tenantType: "fisica",
  tenant: "",
  tenantName: "",
  tenantPhone: "",
  tenantEmail: "",
  requiresGuarantor: false,
  guarantorType: "fisica",
  propertyAsGuarantee: false,
  creditInvestigation: false,
  guarantorProofOfIncome: false,
  guarantorName: "",
  guarantorFirstSurname: "",
  guarantorSecondSurname: "",
  guarantorEmail: "",
  guarantorPhoneNumber: "",
  guarantorDialCode: "+52",
  alternativeJustice: null,
  rentInsurance: null,
  tenantPaysApplication: null,
  webCheckRequired: null,
};

export const ANIMATION_DURATION = 150;
export const VIEW_TRANSITION_DURATION = 400;
